<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Plant Type</td>
            <td>Output Capacity</td>
        </tr>

        <!--for the time being Neil wants to suppress all other fluids except LNG-->
        <tr *ngFor="let lngPlant of lngPlants">
            <td [innerHTML]="lngPlant.lngPlantType | highlight: searchTerm"></td>
            <td>
                <ul class="list-unstyled" style="margin-bottom:0px;">
                    <!-- <li *ngFor="let lngFluid of lngPlant.lngPlantFluids" style="margin-top:2px;" *ngIf="lngFluid.fluidTypeID==12"> -->
                    <li *ngFor="let lngFluid of lngPlant.lngPlantFluids" style="margin-top:2px;"
                        [hidden]="lngFluid.fluidTypeID!=12">
                        <span *ngIf="lngFluid.annualCapacity || lngFluid.trains"
                            [innerHTML]="lngFluid.material | highlight: searchTerm"></span>:
                            <span *ngIf="lngFluid.annualCapacity">{{ lngFluid.annualCapacity }} {{
                                lngFluid.annualRateUnit }}</span>
                            <span *ngIf="!lngFluid.annualCapacity">unknown capacity</span>
                            <span *ngIf="lngFluid.trains"> ({{ lngFluid.trains }} train<span
                                    *ngIf="lngFluid.trains != 1">s</span>)</span>
                        <!-- </span> -->
                        <span *ngIf="!lngFluid.annualCapacity && !lngFluid.trains">unknown</span>
                    </li>
                </ul>
            </td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td>Plant Type</td>
            <td>Output Capacity</td>
        </tr>
        <tr *ngFor="let lngPlant of lngPlants">
            <td [innerHTML]="lngPlant.lngPlantType | highlight:searchTerm"></td>
            <td>
                <ul class="list-unstyled" style="margin-bottom:0px;">
                    <li *ngFor="let lngFluid of lngPlant.lngPlantFluids" style="margin-top:2px;"
                        [hidden]="lngFluid.fluidTypeID!=12">
                        <span *ngIf="lngFluid.annualCapacity || lngFluid.trains"
                            [innerHTML]="lngFluid.material | highlight:searchTerm"></span>: 
                            <span *ngIf="lngFluid.annualCapacity">{{ lngFluid.annualCapacity }} {{
                                lngFluid.annualRateUnit }}</span>
                            <span *ngIf="!lngFluid.annualCapacity">unknown capacity</span>
                            <span *ngIf="lngFluid.trains"> ({{ lngFluid.trains }} train<span *ngIf="lngFluid.trains !== 1">s</span>)</span>
                        
                        <span *ngIf="!lngFluid.annualCapacity && !lngFluid.trains">unknown</span>
                    </li>
                </ul>
            </td>
        </tr>
    </table>
</div>
</ng-template>